import { Sparkles } from "lucide-react";
import type { PoaFeeSuggestion } from "../api";

/** Sugestia „nowa vs istniejąca" dla modala opłaty za pełnomocnictwo. Reguła jest
 *  DETERMINISTYCZNA (zwykły algorytm, bez LLM) — „liczenie" to tylko round-trip do API,
 *  więc animacja miga zwykle krótko. Loading = pulsująca ikona + kropki „myślenia". */
export function PoaSuggestionHint({
  loading, suggestion, showApply, onApply,
}: {
  loading: boolean;
  suggestion?: PoaFeeSuggestion;
  showApply: boolean;
  onApply: () => void;
}) {
  if (loading) {
    return (
      <div className="flex items-center gap-2 rounded border border-[var(--color-primary)]/30 bg-[var(--color-primary)]/5 px-2.5 py-2">
        <Sparkles size={14} className="shrink-0 text-[var(--color-primary)] animate-pulse" />
        <span className="text-[var(--color-text-muted)] animate-pulse">Analizuję dostępne opłaty…</span>
        <span className="ml-1 flex gap-1">
          {[-0.24, -0.12, 0].map((d) => (
            <span
              key={d}
              className="h-1.5 w-1.5 rounded-full bg-[var(--color-primary)]/70 animate-bounce"
              style={{ animationDelay: `${d}s` }}
            />
          ))}
        </span>
      </div>
    );
  }
  if (!suggestion) return null;
  return (
    <div className="flex items-start gap-2 rounded border border-[var(--color-primary)]/40 bg-[var(--color-primary)]/5 px-2.5 py-2">
      <Sparkles size={14} className="mt-0.5 shrink-0 text-[var(--color-primary)]" />
      <div className="flex-1">
        <span className="text-[var(--color-text-secondary)]">{suggestion.reason}</span>
        {showApply && (
          <button type="button" className="ml-2 underline text-[var(--color-primary)]" onClick={onApply}>
            Zastosuj sugestię
          </button>
        )}
      </div>
    </div>
  );
}
